
import React, { useEffect, useState, useCallback, useMemo } from "react";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import "../_components/antd.css";

import { Table, Tooltip } from "antd";
import {
  onShowSizeChange,
  itemRender,
  showTotal
} from "../_components/paginationfunction";
//import Data from "../assets/jsons/vendors";

import api from "../api/api"
import { Link } from "react-router-dom";
import Filter from "./Filter"
import { filterIcon } from "../_components/Imagepath";
import { useAuth } from "../context/AuthContext";

import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useTranslation } from 'react-i18next';

import SuperBiodataMobile from "./SuperBiodataMobile"
import SearchCard from "./SearchCard"
import DeleteModal from "./DeleteModal";
import * as Icon from "react-feather";



const SuperBiodata = () => {

  const { user } = useAuth()
  const { t } = useTranslation();


  const [selectedBiodata, setSelectedBiodata] = useState(null);
  const [keyword, setKeyword] = useState("");
  const [employer, setEmployer] = useState("");
  const [activeTab, setActiveTab] = useState(user.type === "supplier" ? "vendor" : "agency");
  
  const [employers, setEmployers] = useState([]);


  const [menu, setMenu] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [loadingForm, setLoadingForm] = useState(false);
  const [error, setError] = useState(null);
  const [pageTitle, setPageTitle] = useState("Super Biodata");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  
  const [data, setData] = useState([]);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);
 


  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const isMobileDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  };


     const fetchDataEmployers = async () => {
        if (user.type !== "agency") return; // Only fetch if user is an agency
        try {
            const response = await api.get("/get-employer");
            setEmployers(response.data.employers);
        } catch (error) {
            let errorMessage = "";
            // Extract response code if available
            const responseCode = error.response ? error.response.status : "Unknown";
            console.log("Response Code:", responseCode);
            if (error?.response?.data) {
                Object.entries(error.response.data).forEach(([key, values]) => {
                    console.log(key, values);
                    errorMessage += `${values}\n`;
                }
                );
            }
        }
    }


  const fetchData = async (page = 1, searchKeyword = keyword, employerParam = employer, tabType = activeTab) => {
    //{loadingForm && <i className="fa-solid fa-spinner fa-spin" style={{margin: "0 10px"}}></i> }

    setLoadingForm(true)
    setError(null)


    try {

      //if (!user.token) return
      let typeurl = "";
      if (tabType === "agency") {
          typeurl = "/super-agency-biodata/";
      } else if (tabType === "vendor") {
          typeurl = "/super-supplier-biodata/";
      } else {
          return;
      }
      
      const params = {};
      
      // Add search parameter if keyword exists
      if (searchKeyword && searchKeyword.trim() !== "") {
        params.search = searchKeyword.trim();
      }

      if (employerParam) {
        params.employer = employerParam; // Add employer parameter if provided
      }
      
      // get all params in the url
      for (const [key, value] of searchParams.entries()) {
          if (key !== 'search') { // Avoid duplicate search param
            params[key] = value;
          }
      }

      const response = await api.get(typeurl + `?page=${page}`, {
        params: params,
      });


      // Handle success based on status code
      if (response.status === 200 || response.status === 201) {
        const arrayData = response.data.results;
        if (Array.isArray(arrayData)) {

          //the prop children is causing error on table
          const showdData = arrayData.map(({ children, ...rest }) => ({

            enfants: children, // Rename 'children' to 'enfants'
            ...rest,
          }));
        
          setData(showdData)
          setCount(response.data.count);
          setNextPage(response.data.next);
          setPrevPage(response.data.previous);

        } else {

          console.error("Data is not an array:", arrayData);


          setError(response.status)
        }

      }

    } catch (error) {
      console.error("API Error:", error);

      if (error.response) {
        // The request was made and the server responded with a status code
        console.log("Error Status:", error.response.status);
        const responseCode = error.response.data.detail ? error.response.data.detail : "Unknown";

        setError(responseCode)
        setError(error.response.status);
      } else if (error.request) {
        // The request was made but no response was received
        console.log("No response received:", error.request);
        setError("No response from server");
      } else {
        // Something happened in setting up the request
        console.log("Error setting up request:", error.message);
        setError("Request setup error");
      }


    } finally {


      setLoadingForm(false);
    }
  }

 


  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  const handlePageChange = (page) => {
    if (page < 1 || page > Math.ceil(count / 10)) return; // Prevent invalid page numbers
    setCurrentPage(page);
    fetchData(page);
  };

  // Add search input change handler (for typing)
  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    setKeyword(value);
  };

  const handleEmployerChange = (e) => setEmployer(e.target.value);

  // Add search submit handler (for button click)
  const handleSearchSubmit = (e) => {
    e.preventDefault(); // Prevent form submission
    setCurrentPage(1); // Reset to first page when searching
    fetchData(1, keyword, employer); // Fetch data with search parameters
  };

  // Add clear search function
  const handleClearSearch = () => {
    setKeyword("");
    setEmployer("");
    setCurrentPage(1);
    fetchData(1, "", ""); // Clear all search parameters
  };

  // Add tab change handler
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
    fetchData(1, keyword, employer, tab);
    fetchDataEmployers();
  };
 

  useEffect(() => {
    fetchData(1, keyword, employer, activeTab);
    fetchDataEmployers();
    setPageTitle(`Super ${activeTab === "agency" ? "Agency" : "Vendor"} Biodata`);
  }, [activeTab])

  useEffect(() => {
    fetchData(1, keyword, employer, activeTab);
    setCurrentPage(1);
  }, [location.search]);



function capitalizeFirstChar(str) {
  if (!str) return ''; // handle empty string
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const columns = useMemo(() => [
  
    {
      title: "Action",
      dataIndex:  "id",
      sorter: false,
      render: (value, record) => (
        <>
          <button
           className="btn btn-danger"
           data-bs-toggle="modal"
           data-bs-target="#deleteModal"
           onClick={() => setSelectedBiodata(record)}
           >Delete</button>
        </>
      ),
    },  
    {
      title: "Name",
      dataIndex: "name",
      sorter:false,
      render: (value,record) => (

        <h2 className="table-avatar">
          <Link to={{
        pathname: "/biodata/" + record.id,
        state: { profile: record },
        }} className="avatar-biodata me-2">
          {record.imgprofile ? (
            <img
              className="avatar-img rounded"
              src={record.imgprofile}
       
              alt="User"
            />
          ) : (
           
            <div style={{width:"100px",height:"100px",alignContent: "center",textAlign:"center"}}>
              <i className="fas fa-user text-muted" style={{ fontSize: "50px" }}></i>
            </div>
          )}
          </Link>
          <Link to={{
        pathname: "/biodata/" + record.id,
        state: { profile: record },
        }}>
            {record.name} <span>

             {activeTab === "vendor" ? record.code : (record.supplier_name ? record.supplier_name : (localStorage.getItem("company_name") ? localStorage.getItem("company_name") : "All Biodata"))} 
               
               </span>
          </Link>
        </h2>

      ),
    
    },
    ...(activeTab === "agency" ? [{
      title: "Code",
      dataIndex: "code",
      render: (value) =>  value,
      sorter: false,
    }] : []),
   
    {
      title: "Status",
      dataIndex: "status",
      render: (value) => {
        let colorClassStatus=""
        if (value === "Published") colorClassStatus = "bg-success-light";
        else if (value === "Draft") colorClassStatus = "bg-info";
        else if (value === "On-Hold") colorClassStatus = "bg-light border text-black";
        else if (value === "Booked") colorClassStatus = "bg-primary-light";
        else if (value === "Unavailable") colorClassStatus = "bg-dark";
        else if (value === "Removed") colorClassStatus = "bg-danger";
          return(<div>
            <span className={`badge badge-pill ${colorClassStatus}`} >{value}</span> 
             
          </div>)
      },
      sorter: (a, b) => (a.status || '').localeCompare(b.status || ''),
  }, {
  title: "Created By",
  dataIndex: activeTab === "agency" ? "agency" : "supplier",
  sorter: false,
  render: (value, record) => {
    const companyType = activeTab === "agency" ? "agency" : "supplier";
    const userData = record[companyType];
    
    
    if (!userData) {
      return (
        <div style={{color:"black"}}>
          <p><strong>User:</strong> N/A</p>
          <p><strong>Role:</strong> N/A</p>
          <p><strong>Company name:</strong> N/A</p>
          <p><strong>Admin email:</strong> N/A</p>
        </div>
      );
    }

    const companyInfo = userData?.[companyType] || {};
    const isAdmin = userData?.is_admin ? "Admin" : "Staff";

    const companyName = typeof companyInfo.name === "string" 
      ? companyInfo.name 
      : JSON.stringify(companyInfo.name ?? "N/A");

    const adminEmail = typeof companyInfo.admin_email === "string"
      ? companyInfo.admin_email
      : JSON.stringify(companyInfo.admin_email ?? "N/A");

    return (
      <div style={{color:"black"}}>
        <p><strong>User:</strong> {capitalizeFirstChar(userData.name || "N/A")}</p>
        <p><strong>Role:</strong> {isAdmin}</p>
        <p><strong>Company name:</strong> {companyName}</p>
        <p><strong>Admin email:</strong> {adminEmail}</p>
      </div>
    );
  }
},
{
      title: "Shared With Employers",
      dataIndex: "shared_with_employer",
      render: (value) => {
        if (!value || value.length === 0) {
          return <span className="badge badge-pill bg-secondary" style={{padding: "7px 20px"}}>No Employers</span>;
        }
        return (
           <div style={{ display: "flex", flexWrap: "wrap" ,maxWidth:"250px"}}>
                    {value.map((employer, index) => (
                        <span key={index} title={employer} className="m-1 badge badge-pill bg-info text-truncate"style={{padding: "7px 20px"}}>{employer}</span>
                    ))}
                </div>
        );
      },
},
...(activeTab === "vendor" ? [{
  title: "Shared With Agencies",
  dataIndex: "shared_with_agency",
  render: (value) => {
    if (!value || value.length === 0) {
      return <span className="badge badge-pill bg-secondary"style={{padding: "7px 20px"}}>No Agencies</span>;
    }
    return (
      <div style={{ display: "flex", flexWrap: "wrap", maxWidth: "250px" }}>
        {value.map((agency, index) => (
          <span key={index} title={agency} className="m-1 badge badge-pill bg-info text-truncate"style={{padding: "7px 20px"}}>{agency}</span>
        ))}
      </div>
    );
  },
}] : []),
{
  title: "Created At",
  dataIndex: "created_at",
  sorter: (a, b) =>  (a.created_at	 || '').localeCompare(b.created_at	 || ''),
},

{
  title: "Last Modified",
  dataIndex: "updated_at",

  sorter: (a, b) =>  (a.updated_at	 || '').localeCompare(b.updated_at	 || ''),
  
}

  ], [activeTab]); // Add activeTab as dependency


  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Add event listener for resizing
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);




  return (


    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        {(loadingForm || error) ? (
          <div style={{ textAlign: "center", margin: "10em" }}>
            {loadingForm && <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: "4em" }} />}
            {error && (
              <div className="alert alert-danger alert-dismissible fade show" role="alert">
                <strong>Error!</strong> {error}
                {/*<button onClick={fetchData} className="btn btn-danger btn-sm ms-3">
                    Try Again
                  </button>*/}
              </div>
            )}
          </div>
        ) : (
          <>

            <div className="content container-fluid">
              {/* Page Header */} 
              <div className="page-header">
                <div className="content-page-header ">
                  <h5>{pageTitle}</h5>
                  
                  {/* Add Tab Navigation */}
                  <div className="tab-navigation">
                    <ul className="nav nav-tabs" role="tablist">
                      <li className="nav-item" role="presentation">
                        <button
                          className={`nav-link ${activeTab === "vendor" ? "active" : ""}`}
                          onClick={() => handleTabChange("vendor")}
                          type="button"
                          role="tab"
                        >
                          <Icon.Users className="me-2" size={16} />
                          {t("Vendor")}
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className={`nav-link ${activeTab === "agency" ? "active" : ""}`}
                          onClick={() => handleTabChange("agency")}
                          type="button"
                          role="tab"
                        >
                          <Icon.Users className="me-2" size={16} />
                          {t("Agency")}
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div className="list-btn">
                    <ul className="filter-list">
                  
                      {/* <li>
                        <a
                          className="btn btn-filters w-auto popup-toggle me-2"
                          onClick={() => setShowFilter(!showFilter)}
                        >
                          <span className="me-2">
                          <Tooltip title="Filter" placement="bottom">
                          <img src={filterIcon} alt='filtericon'/>
                          </Tooltip>
                          </span>
                          {t("Filter")}{" "}
                        </a>
                      </li> */}
                    
                    </ul>
                  </div>
                </div>
              </div>

          
              <div className="row">
                <div className="col-sm-12">

                  <SearchCard
                    keyword={keyword}
                    employer={employer}
                    employers={employers}
                    user={user}
                    handleSearchInputChange={handleSearchInputChange}
                    handleEmployerChange={handleEmployerChange}
                    handleSearchSubmit={handleSearchSubmit}
                    handleClearSearch={handleClearSearch}
                  />
                  

                  {isMobileDevice() || screenWidth <= 576 ? (
                    <>
                      <SuperBiodataMobile activeTab={activeTab} handlePageChange={handlePageChange} currentPage={currentPage} nextPage={nextPage} prevPage={prevPage} count={count} data={data}/>
                    </>
                  ) : (
                    <div className="p-3 bg-white rounded">
                      <div className=" card-table">
                        <div className="card-body vendors">
                          <div className="table-responsive table-hover table-striped">
                            <Table
                              pagination={{
                                total: count,
                                current: currentPage,
                                showTotal: (length,range) => showTotal(t,length, range),
                                onShowSizeChange: onShowSizeChange,
                                itemRender:  (page, type, originalElement) => itemRender(t, handlePageChange, currentPage, prevPage, nextPage, page, type, originalElement),
                              }}
                              columns={columns}
                              dataSource={data}
                              scroll={{ x: "max-content" }}
                            />
                          </div>
                        </div>
                      </div>

                    </div>
                  )}
                </div>
              </div>
          </div>
     
          </>
          )}

            { <Filter setShow={setShowFilter} show={showFilter} /> }
            <DeleteModal biodata={selectedBiodata} fetchData={fetchData} />
     
        </div >
      </div >
  );
};

export default SuperBiodata;
